import {
	COMPANY_MENU_STATUS_LABELS,
	resolveCompanyMenuKeyFromSearch,
} from 'src/utils/data/company-statuses';

const makeCrumbs = (firstLabel, href, statusLabel) => ({
	links: [
		{ id: 1, label: firstLabel, href },
		{ id: 2, label: statusLabel },
	],
});

const SECTIONS = {
	'/commission': {
		label: 'Комиссионные подключения',
		href: '/commission',
	},
	'/abonent': {
		label: 'Абонентские',
		href: '/abonent',
	},
	'/account-management': {
		label: 'Аккаунт-менеджмент',
		href: '/account-management',
	},
	'/content-management': {
		label: 'Контент-менеджмент',
		href: '/content-management',
	},
	'/calls': {
		label: 'Звонки',
		href: '/calls',
	},
	'/objection': {
		label: 'Возражения',
		href: '/objection',
	},
	'/worth': {
		label: 'Оценка',
		href: '/worth',
	},
};

const getWorthStatusLabel = (searchParams) => {
	const op = searchParams.get('filter.required.op');
	const value = searchParams.get('filter.required.value');

	if (op === 'eq' && value === 'true') return 'Требуют оценки';
	if (op === 'eq' && value === 'false') return 'Оцененные';

	return 'Все';
};

export const getTablePageCrumbs = (pathname, search = '') => {
	const section = SECTIONS[pathname];
	if (!section) return null;

	const searchParams =
		typeof search === 'string' ? new URLSearchParams(search) : search;

	if (pathname === '/worth') {
		return makeCrumbs(
			section.label,
			section.href,
			getWorthStatusLabel(searchParams),
		);
	}

	if (pathname === '/objection' || pathname === '/calls') {
		return makeCrumbs(section.label, section.href, 'Все');
	}

	const menuKey = resolveCompanyMenuKeyFromSearch(searchParams);
	const statusLabel =
		COMPANY_MENU_STATUS_LABELS[menuKey] || COMPANY_MENU_STATUS_LABELS.all;

	return makeCrumbs(section.label, section.href, statusLabel);
};

export const bidsCrumbs = (statusLabel) =>
	makeCrumbs('Комиссионные подключения', '/commission', statusLabel);
export const callsCrumbs = (statusLabel) =>
	makeCrumbs('Звонки', '/calls', statusLabel);
export const objectionsCrumbs = (statusLabel) =>
	makeCrumbs('Возражения', '/objection', statusLabel);
export const worthCrumbs = (statusLabel) =>
	makeCrumbs('Оценка', '/worth', statusLabel);
